// TODO: The icons are here because this is an experimental feature that may be removed.
import FirstIcon from '@assets/images/icons/export/first-icon.svg?react'
import SecondIcon from '@assets/images/icons/export/second-icon.svg?react'
import ThirdIcon from '@assets/images/icons/export/third-icon.svg?react'
import type React from 'react'

import { useExportAsPrompt } from '@/hooks'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

export const ExportPrompt: React.FC = () => {
  const onClick = useExportAsPrompt(true)

  return (
    <div className={css.export_prompt} onClick={onClick}>
      <div className={css.wrap}>
        <div className={css.icon_wrap}>
          <FirstIcon />
        </div>
        <div className={clsJoin(css.icon_wrap, css.second)}>
          <SecondIcon />
        </div>
        <div className={clsJoin(css.icon_wrap, css.third)}>
          <ThirdIcon />
        </div>
      </div>
      <div className={css.export_prompt_label}>AI website builders</div>
    </div>
  )
}
